module.exports = __webpack_public_path__ + "static/media/infoJumbo3.36733f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Almi/images/infoJumbo3.png
// module id = 499
// module chunks = 0